import ReactStrapTable from "components/reactStrapTable";
import React, { useState } from "react";
import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { Field, Formik } from "formik";
import ArrowRight from "assets/icon/arrow-right-purple.svg";
import plusIcon from "assets/icon/plus-rx.svg";
import { useNavigate } from "react-router-dom";
import SearchContainer from "pages/OrderEntry/SearchContainer/Index";
import leftArrow from "assets/icon/left-arrow.svg";
import scanIcon from "assets/icon/scan-icon.svg";
import ZoomInIcon from "assets/icon/zoom-in-icon.svg";
import ZoomOutIcon from "assets/icon/zoom-out-icon.svg";
import DeleteIcon from "assets/icon/delete-icon.svg";
import patientsScanImage from "assets/images/patients-scan.svg";
import resetBtnIcon from "assets/icon/reset-btn-icon.svg";
import saveBtnIcon from "assets/icon/save-btn-icon.svg";
import submitBtnIcon from "assets/icon/submit-btn-icon.svg";
import plusIconAllergies from "assets/icon/plus-allergies-icon.svg";
import cancelIcon from "assets/icon/cancel-icon.svg";
import { toast } from "react-toastify";
import Confirm from "components/Confirm";
import saveIcon from "assets/icon/save-btn-icon.svg";
import submitIcon from "assets/icon/submit-btn-icon.svg";
import resetIcon from "assets/icon/reset-btn-icon.svg";
import upArrow from "assets/inventory/up-arrow.svg";
import downArrow from "assets/inventory/down-arrow.svg";
import Calendar from "assets/icon/calendar-pms.svg";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import moment from "moment";
import ScanIcon from "assets/icon/scan-icon.svg";
import closeIcon from "assets/icon/close.svg";
import addBlackIcon from "assets/icon/add-black-icon.svg";
import addIcon from "assets/icon/add.svg";

const EditPatientDetails = () => {
  const [focusedInput, setFocusedInput] = useState("");
  const [error, setError] = useState(false);
  const [isSubmited, serIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scale, setScale] = useState(1);
  const [isImageVisible, setIsImageVisible] = useState(true);
  const initialImage = patientsScanImage;
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("2");
  const [openFour, setOpenFour] = useState(false);
  const [openFive, setOpenFive] = useState("");
  const [openSix, setOpenSix] = useState("");
  const [startDate, setStartdate] = useState(null);
  const [patientData, setPatientData] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({
    firstName: "",
    lastName: "",
    option1: "",
    option2: "",
    male: "",
    female: "",
    state: "",
    country: "",
    language: "",
    translations: "",
    childsafety: "",
  });
  const [data, setData] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });
  const [allergies, setAllergies] = useState([
    { id: 1, data: "Penicillin" },
    { id: 2, data: "Sulfa" },
  ]);

  const handleSubmit = () => {
    setAllergies((prev) => [
      ...prev,
      { id: Date.now(), data: selectedOptions.data },
    ]);
    setSelectedOptions((prev) => ({ ...prev, data: "" }));
  };

  const handleDeleteAl = (id) => {
    setAllergies((prev) => prev.filter((item) => item.id !== id));
  };
  const [todosOne, setTodosOne] = useState([]);
  const [todosTwo, setTodosTwo] = useState([]);
  const [todosThree, setTodosThree] = useState([]);
  const [todosFour, setTodosFour] = useState([]);
  const [confirm, setConfirm] = useState(false);

  const [increment, setIncrement] = useState({
    totalQtyWritten: 0,
    serialNo: 0,
    partialFillQty: 0,
  });

  const handleChangeIncrement = (e) => {
    const { name, value } = e.target;
    setIncrement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleIncrement = () => {
    setIncrement((prevState) => ({
      ...prevState,
      totalQtyWritten: prevState.totalQtyWritten + 1,
    }));
  };
  const handleDecrement = () => {
    if (increment.totalQtyWritten > 0) {
      setIncrement((prevState) => ({
        ...prevState,
        totalQtyWritten: prevState.totalQtyWritten - 1,
      }));
    }
  };

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handlesDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };

  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };

  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };
  const togglebtnFour = (id) => {
    if (openFour === id) {
      setOpenFour();
    } else {
      setOpenFour(id);
    }
  };
  const togglebtnFive = (id) => {
    if (openFive === id) {
      setOpenFive();
    } else {
      setOpenFive(id);
    }
  };
  const togglebtnSix = (id) => {
    if (openSix === id) {
      setOpenSix();
    } else {
      setOpenSix(id);
    }
  };

  const navigate = useNavigate();

  const goback = () => {
    navigate(-1);
  };
  const handleClick = () => {
    navigate("/workflow-orderEntry-addNewPatient");
  };
  const onsubmit = () => {
    toast.success("E-Prescription has successfully approved");
  };
  const handleZoomIn = () => {
    setScale((prevScale) => prevScale + 0.2); // Increase the scale by 0.2
  };
  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5)); // Decrease the scale, minimum scale is 0.5
  };
  const handleDelete = (e) => {
    setIsImageVisible(true);
  };
  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleSaveConfirmation = () => {
    setConfirm(!confirm);
  };
  const handleSubmitAllergies = (field) => {
    const newEntry = { id: Date.now(), value: data[field] };

    switch (field) {
      case "one":
        if (data.one !== "") {
          setTodosOne([...todosOne, newEntry]);
        }
        break;
      case "two":
        if (data.two !== "") {
          setTodosTwo([...todosTwo, newEntry]);
        }
        break;
      case "three":
        if (data.three !== "") {
          setTodosThree([...todosThree, newEntry]);
        }
        break;
      case "four":
        if (data.four !== "") {
          setTodosFour([...todosFour, newEntry]);
        }
        break;
      default:
        break;
    }

    setData({ ...data, [field]: "" });
  };

  const handleDeleteAllergies = (id, field) => {
    switch (field) {
      case "one":
        setTodosOne(todosOne.filter((item) => item.id !== id));
        break;
      case "two":
        setTodosTwo(todosTwo.filter((item) => item.id !== id));
        break;
      case "three":
        setTodosThree(todosThree.filter((item) => item.id !== id));
        break;
      case "four":
        setTodosFour(todosFour.filter((item) => item.id !== id));
        break;
      default:
        break;
    }
  };
  const goBack = () => {
    setConfirm(true);
  };

  const onLeave = async () => {
    handleSaveConfirmation();
  };
  const handleChangeHandler = (e) => {
    const { name, value } = e.target;
    setPatientData({ ...patientData, [name]: value });
    console.log(patientData);
  };

  return (
    <Container fluid className="details-page-body bg-white p-l-16 p-r-16" style={{width:"84vw"}}>
      <Container fluid className="packaging-edit-accordian-div" >
        <div className=" mt-2">
          <Formik>
            <FormGroup>
              <Accordion open={false} toggle={togglebtnTwo} className="mb-1">
                <AccordionHeader targetId="1">Demographics</AccordionHeader>
                <AccordionBody accordionId="1">
                  <Row className="mb-0 mt-1">
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Patient First Name</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          value={patientData.firstName}
                          name="firstName"
                          onChange={handleChangeHandler}
                          placeholder="Enter First Name"
                        />
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Patient Last Name</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          value={patientData.lastName}
                          name="lastName"
                          onChange={handleChangeHandler}
                          placeholder="Enter Last Name"
                        />
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Patient Middle Initial/Name</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          // value={increment.totalQtyWritten}
                          name="totalQtyWritten"
                          // onChange={handleChangeIncrement}
                          placeholder="Enter Middle Name"
                        />
                      </InputGroup>
                    </Col>
                    <Col className="required-date">
                      <Label className=" ">Date of Birth</Label>
                      <FormGroup>
                        <InputGroup
                          onMouseLeave={handleMouseLeave}
                          className="date-14px"
                        >
                          <DatePicker
                            id="startDate"
                            name="dob"
                            selected={startDate}
                            onChange={(startDate) => handleStartDate(startDate)}
                            onFocus={() => handleFocus("StartDate")}
                            onBlur={handleBlur}
                            isClearable
                            onChangeRaw={handleStartDateRaw}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select Date"
                            autoComplete="off"
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={startDate}
                              />
                            }
                          />
                          <InputGroupText
                            // onClick={() => handlesDateClick("startDate")}
                            onClick={undefined}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "-6px" }}>
                    <Col
                      sm={3}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Gender</Label>
                      <InputGroup>
                        <Field
                          as="select"
                          name="male"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.male}
                          onChange={handleChangeOption}
                        >
                          <option value="" disabled hidden>
                            Select Gender
                          </option>
                          <option value="male" label="Male" />
                          <option value="female" label="Female" />
                        </Field>
                      </InputGroup>
                    </Col>
                  </Row>
                  <div className="sep-form"></div>
                  <Row className="mt-1">
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">City</Label>
                      <InputGroup className="">
                        <Field
                          as="select"
                          name="city"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.city}
                          onChange={handleChangeOption}
                        >
                          <option value="">Select City</option>
                          <option>Chicago</option>
                          <option>Springfield</option>
                          <option>Rockford</option>
                        </Field>
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1 "
                    >
                      <Label className="">State/Province</Label>
                      <InputGroup>
                        <Field
                          as="select"
                          name="state"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.state}
                          onChange={handleChangeOption}
                        >
                          <option value="">Select State</option>
                          <option>New Jercy</option>
                          <option>Illinois</option>
                          <option>Oklahoma</option>
                        </Field>
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Country/Parish</Label>
                      <InputGroup className="">
                        <Field
                          as="select"
                          name="country"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.country}
                          onChange={handleChangeOption}
                        >
                          <option value="">Select Country</option>
                          <option>USA</option>
                          <option>India</option>
                          <option>Canada</option>
                        </Field>
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Primary Phone</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          // value={increment.totalQtyWritten}
                          name="totalQtyWritten"
                          // onChange={handleChangeIncrement}
                          placeholder="Enter Number"
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Secondary Phone</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          // value={increment.totalQtyWritten}
                          name="totalQtyWritten"
                          // onChange={handleChangeIncrement}
                          placeholder="Enter Number"
                        />
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0 mb-1"
                    >
                      <Label className="">Email</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          // value={increment.totalQtyWritten}
                          name="totalQtyWritten"
                          // onChange={handleChangeIncrement}
                          placeholder="Enter Mail ID"
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <div className="sep-form"></div>
                  <Row className="mt-1">
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0"
                    >
                      <Label className="">Primary Prescriber</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          // value={increment.totalQtyWritten}
                          name="totalQtyWritten"
                          // onChange={handleChangeIncrement}
                          placeholder="Enter Prescriber"
                        />
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0"
                    >
                      <Label className="">Preferred Language </Label>
                      <InputGroup className="">
                        <Field
                          as="select"
                          name="language"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.language}
                          onChange={handleChangeOption}
                        >
                          <option value="">Select Language</option>
                          <option>English</option>
                          <option>Hindi</option>
                          <option>French</option>
                        </Field>
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0"
                    >
                      <Label className="">Requires Translation </Label>
                      <InputGroup className="">
                        <Field
                          as="select"
                          name="translations"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.translations}
                          onChange={handleChangeOption}
                        >
                          {" "}
                          <option value="">Select Translation</option>
                          <option value="">No</option>
                          <option>Yes</option>
                        </Field>
                      </InputGroup>
                    </Col>
                    <Col
                      sm={12}
                      md={3}
                      className="inc controls textarea_info search-flex mb-0"
                    >
                      <Label className="">Child Safety Caps </Label>
                      <InputGroup className="">
                        <Field
                          as="select"
                          name="childsafety"
                          id="option"
                          className="order-detail-input"
                          value={selectedOptions.childsafety}
                          onChange={handleChangeOption}
                        >
                          <option value="">Yes</option>
                          <option>No</option>
                        </Field>
                      </InputGroup>
                    </Col>
                  </Row>
                </AccordionBody>
              </Accordion>
              <Accordion
                open={openThree}
                toggle={togglebtnThree}
                className="mb-1"
              >
                <AccordionHeader targetId="2">Allergies</AccordionHeader>
                <AccordionBody accordionId="2">
                  {" "}
                  <Row>
                    <Col md="12">
                      {/* <div className="inv-details">Allergies </div> */}
                      {/* <div className="veterinary-patient p-2 m-0"> */}
                      <InputGroup className="bg-white">
                        <Input
                          placeholder="Add New Allergy"
                          name="data"
                          value={selectedOptions.data}
                          onChange={handleChangeOption}
                        />
                        {selectedOptions.data ? (
                          <img
                            src={addIcon}
                            alt=""
                            className="m-1 cursor-pointer"
                            onClick={handleSubmit}
                          />
                        ) : (
                          <img
                            src={addBlackIcon}
                            alt=""
                            className="m-1 cursor-pointer"
                            onClick={handleSubmit}
                          />
                        )}
                      </InputGroup>
                      <div className="d-flex justify-content-start align-items-center direction-row gap-2">
                        {allergies.map((name) => (
                          <div className="allergies-add-data" key={name.id}>
                            <div>{name.data}</div>
                            <div onClick={() => handleDeleteAl(name.id)}>
                              <img
                                src={closeIcon}
                                alt=""
                                className="cursor-pointer"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* </div> */}
                    </Col>
                  </Row>
                </AccordionBody>
              </Accordion>
              <Accordion
                open={openFour}
                toggle={togglebtnFour}
                className="mb-1"
              >
                <AccordionHeader targetId="1">Insurance Plan</AccordionHeader>
                <AccordionBody accordionId="1"></AccordionBody>
              </Accordion>
              <Accordion
                open={openFive}
                toggle={togglebtnFive}
                className="mb-1"
              >
                <AccordionHeader targetId="1">
                  Dispensing Preferences
                </AccordionHeader>
                <AccordionBody accordionId="1"></AccordionBody>
              </Accordion>
              <Accordion open={openSix} toggle={togglebtnSix} className="mb-1">
                <AccordionHeader targetId="1">Communications</AccordionHeader>
                <AccordionBody accordionId="1"></AccordionBody>
              </Accordion>
              <Accordion open={false} toggle={togglebtnOne}>
                <AccordionHeader targetId="1" className="mb-1">
                  Scan Rx
                </AccordionHeader>
                <AccordionBody accordionId="1">
                  <Row className="parent-scan">
                    <Col
                      // lg={12}
                      style={{
                        backgroundColor: "#F7F7F7",
                        minHeight: "158px",
                        maxHeight: "auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {scale ? (
                        <>
                          {isImageVisible ? (
                            <>
                              {/* <Row>
                            <Col>Re assign</Col>
                            <Col>print</Col>
                            <Col>Farword rx</Col>
                            <Col>options</Col>
                          </Row> */}
                              <div>
                                <Row>
                                  <Button
                                    color="dark"
                                    className="primary dark"
                                    onClick={() => {
                                      setIsImageVisible(false);
                                      setIsButtonEnabled(true);
                                    }}
                                  >
                                    Scan
                                    <img src={ScanIcon} />
                                  </Button>
                                </Row>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex justify-content-between">
                              <div>
                                <img
                                  src={patientsScanImage} // Replace with your image URL
                                  alt="Zoomable"
                                  style={{
                                    transform: `scale(${scale})`,
                                    transition: "transform 0.3s ease",
                                    maxWidth: "100%",
                                    display: "block",
                                    height: "auto",
                                    padding: "10px",
                                    overflow: "auto",
                                  }}
                                />
                              </div>
                              <div style={{ zIndex: "999" }}>
                                <div>
                                  <img
                                    src={ZoomInIcon}
                                    onClick={handleZoomIn}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={ZoomOutIcon}
                                    onClick={handleZoomOut}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={DeleteIcon}
                                    onClick={handleDelete}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </AccordionBody>
              </Accordion>
            </FormGroup>
          </Formik>
        </div>
      </Container>
      <Container fluid className="rx-detail-footer">
        {!patientData.firstName || !patientData.lastName ? (
          <>
            <div>
              <Button
                className="reset "
                style={{
                  color: "#9E9E9E",
                  // backgroundColor: "white",
                  borderColor: "none",
                }}
                color="tranparent"
              >
                <img src={resetIcon} />
                Reset
              </Button>
            </div>
            <div className="d-flex  align-items-end">
              <Button
                className="back-button"
                style={{
                  color: "#9E9E9E",
                  borderColor: "1px solid ",
                  // backgroundColor: "white",
                  borderColor: "9E9E9E",
                }}
                // color="tranparent"
                disabled={!isButtonEnabled}
              >
                <img src={saveIcon} />
                Save
              </Button>

              <Button
                style={{
                  color: "#9E9E9E",
                  backgroundColor: "#D3D3D3",
                  borderColor: "9E9E9E",
                }}
                color="tranparent"
                className="submit "
                onClick={onsubmit}
                disabled={!isButtonEnabled}
              >
                <img src={submitIcon} />
                Submit
              </Button>
            </div>
          </>
        ) : (
          <>
            <div>
              <Button color="primary" className="reset ">
                <img src={resetIcon} />
                Reset
              </Button>
            </div>
            <div className="d-flex  align-items-end">
              <Button className="back-button">
                <img src={saveIcon} />
                Save
              </Button>

              <Button
                color="primary"
                className="submit "
                onClick={onsubmit}
                // disabled={!isButtonEnabled}
              >
                <img src={submitIcon} />
                Submit
              </Button>
            </div>
          </>
        )}
      </Container>
    </Container>
  );
};

export default EditPatientDetails;
